import { render, staticRenderFns } from "./namefrom.vue?vue&type=template&id=a7ad0c3c&scoped=true&"
import script from "./namefrom.vue?vue&type=script&lang=js&"
export * from "./namefrom.vue?vue&type=script&lang=js&"
import style0 from "./namefrom.vue?vue&type=style&index=0&id=a7ad0c3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ad0c3c",
  null
  
)

export default component.exports